// Getters
export const REQUESTS_SEARCH_RESULT = 'snapshot_change/REQUESTS_SEARCH_RESULT'
export const REQUEST_SIDEBAR = 'snapshot_change/REQUEST_SIDEBAR'
export const APPROVERS_SEARCH_RESULT = 'snapshot_change/APPROVERS_SEARCH_RESULT'
export const APPROVER_SIDEBAR = 'snapshot_change/APPROVER_SIDEBAR'

// Mutations
export const MUTATE_REQUESTS_SEARCH_RESULT = 'snapshot_change/MUTATE_REQUESTS_SEARCH_RESULT'
export const MUTATE_REQUEST_SIDEBAR = 'snapshot_change/MUTATE_REQUEST_SIDEBAR'
export const MUTATE_APPROVERS_SEARCH_RESULT = 'snapshot_change/MUTATE_APPROVERS_SEARCH_RESULT'
export const MUTATE_APPROVER_SIDEBAR = 'snapshot_change/MUTATE_APPROVER_SIDEBAR'

// Actions
export const OPEN_REQUEST_SIDEBAR = 'snapshot_change/OPEN_REQUEST_SIDEBAR'
export const SEARCH_REQUESTS = 'snapshot_change/SEARCH_REQUESTS'
export const GET_REQUESTS_BY_CONTRACT = 'snapshot_change/GET_REQUESTS_BY_CONTRACT'
export const CREATE_REQUEST = 'snapshot_change/CREATE_REQUEST'
export const UPDATE_REQUEST_STATUS = 'snapshot_change/UPDATE_REQUEST_STATUS'
export const OPEN_APPROVER_SIDEBAR = 'snapshot_change/OPEN_APPROVER_SIDEBAR'
export const SEARCH_APPROVERS = 'snapshot_change/SEARCH_APPROVERS'
export const GET_APPROVER_CANDIDATES = 'snapshot_change/GET_APPROVER_CANDIDATES'
export const ADD_APPROVER = 'snapshot_change/ADD_APPROVER'
export const REMOVE_APPROVER = 'snapshot_change/REMOVE_APPROVER'
export const GET_APPROVERS_HISTORY = 'snapshot_change/GET_APPROVERS_HISTORY'
